import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

const BaseUrl = "https://api.shabdtoday.com/";
const online = "https://api.shabdtoday.com/api/home/Opinion";
const online_Count = "https://api.shabdtoday.com/api/home/update-viewcountOpinion";

const OpinionCard = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const observer = useRef();
    const navigate = useNavigate();

    const fetchNews = async () => {
        if (!hasMore) return;

        try {
            const response = await axios.get(`${online}?page=${page}&limit=8`);
            const newData = response.data.opinionMembersModels;

            if (newData.length > 0) {
                setNews((prev) => [...prev, ...newData]);
                setPage(page + 1);
            } else {
                setHasMore(false);
            }

            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNews();
    }, []);

    useEffect(() => {
        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                fetchNews();
            }
        });

        const target = document.getElementById("load-more");
        if (target) observer.current.observe(target);

        return () => observer.current.disconnect();
    }, [news]);

    const goToDetails = async (id) => {
        try {
            await axios.post(online_Count, { MainKhabarId: id });
        } catch {}

        navigate(`/OpinionDetails/${id}`);
    };

    return (
        <>
            <Helmet>
                <title>ओपिनियन – विशेषज्ञों के विचार | ShabdToday</title>
                <meta name="description" content="ओपिनियन और विशेषज्ञों के विचार पढ़ें।" />
            </Helmet>

            <h1 className="page-title">ओपिनियन और विचार</h1>

            {/* GRID */}
            <div className="opinion-grid">
                {news.map((post) => (
                    <div key={post.id} className="opinion-card">
                        <div
                            className="opinion-img-box"
                            onClick={() => goToDetails(post.id)}
                        >
                            <img
                                src={BaseUrl + post.opinion_Image}
                                alt={post.opinion_Heading}
                            />
                        </div>

                        <div className="opinion-content">
                            <h2 onClick={() => goToDetails(post.id)}>
                                {post.opinion_Heading}
                            </h2>

                            {/* Author Section */}
                            <Link
                                to={`/OpinionAccordingTomember/${post.member_Id}`}
                                className="opinion-author"
                            >
                                <img
                                    src={BaseUrl + post.member_Image}
                                    alt={post.member_Name}
                                />
                                <div>
                                    <strong>{post.member_Name}</strong>
                                    <br />
                                    <span>
                                        {new Date(post.opinion_Date).toLocaleDateString(
                                            "hi-IN"
                                        )}
                                    </span>
                                </div>
                            </Link>
                        </div>
                    </div>
                ))}
            </div>

            {/* Loader */}
            <div id="load-more" className="load-more">
                {hasMore ? "Loading..." : "No more opinions"}
            </div>

            <style>
                {`
/* Page Title */
.page-title {
    color: #c10037;
    margin: 20px 10px;
    font-size: 26px;
    font-weight: bold;
}

/* GRID LAYOUT */
.opinion-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
    padding: 10px;
}

/* MOBILE */
@media (max-width: 768px) {
    .opinion-grid {
        grid-template-columns: repeat(1, 1fr);
    }
}

/* CARD */
.opinion-card {
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: rgba(0,0,0,0.12) 0px 4px 12px;
    transition: transform .3s;
}
.opinion-card:hover {
    transform: translateY(-5px);
}

/* IMAGE */
.opinion-img-box img {
    width: 100%;
    height: 220px;
    object-fit: cover;
    cursor: pointer;
}

/* CONTENT */
.opinion-content {
    padding: 12px;
}
.opinion-content h2 {
    font-size: 18px;
    font-weight: 600;
    color: #222;
    cursor: pointer;
    line-height: 1.4;
}
.opinion-content h2:hover {
    color: crimson;
}

/* AUTHOR BOX */
.opinion-author {
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    color: #444;
}
.opinion-author img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
}
.opinion-author span {
    font-size: 12px;
    color: gray;
}

/* Load More */
.load-more {
    text-align: center;
    padding: 20px;
    color: #555;
    font-size: 16px;
}
`}
            </style>
        </>
    );
};

export default OpinionCard;
